import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";
import {UsersModel} from "./users.model";
import {IDataModel} from "../../services/IDataModel";
import {IDataFilter} from "../../services/DataTable";
import {ListResponseModel, ResponseModel} from "../response/response.model";


@Injectable()
export class UsersService implements IDataModel {

    private API_ROOT:string = '/user';

    constructor(private http: Http) {}

    getList(filter?: IDataFilter) : Observable<ListResponseModel<UsersModel>> {
        let params: URLSearchParams = new URLSearchParams();

        if (filter) {
            for(let key in filter) {
                params.set(key, filter[key]);
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOne(id: number): Observable<ResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    getCurrent(): Observable<ResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/me`).map((res) => res.json());
    }

    getFS() : Observable<ListResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/fs`).map((res) => res.json());
    }

    getAll() : Observable<ListResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/all`).map((res) => res.json());
    }

    getOpener() : Observable<ListResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/opener`).map((res) => res.json());
    }

    add (fields: UsersModel) : Observable<ResponseModel<UsersModel>> {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit (id: number, fields: UsersModel) : Observable<ResponseModel<UsersModel>> {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    editCurrent(userSettingsModel) {
        return this.http.put(`${this.API_ROOT}/me`, userSettingsModel).map((res) => res.json());
    }

    remove(id: number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    getSwitchList() : Observable<ListResponseModel<UsersModel>> {
        return this.http.get(`${this.API_ROOT}/switch`).map((res) => res.json());
    }

    setPass(id: number, pass: string): Observable<ResponseModel<UsersModel>> {
        return this.http.put(`${this.API_ROOT}/any-pass`, {id: id, pass: pass}).map((res) => res.json());
    }

    getPermissionsByRole() : Observable<ListResponseModel<any>> {
        return this.http.get(`${this.API_ROOT}/permissions-by-role`).map((res) => res.json());
    }

    addPermissionForRole(id: any, hid: any) : Observable<ListResponseModel<any>> {
        return this.http.post(`${this.API_ROOT}/permissions-by-role`, {id: id, hid: hid}).map((res) => res.json());
    }

    deletePermissionForRole(id: any, hid: any) : Observable<ListResponseModel<any>> {
        return this.http.delete(`${this.API_ROOT}/permissions-by-role`, {body: {id: id, hid: hid}}).map((res) => res.json());
    }

    addNewRole(name: any) : Observable<ListResponseModel<any>> {
        return this.http.post(`${this.API_ROOT}/role`, {name: name}).map((res) => res.json());
    }

    deleteRole(id: any) : Observable<ListResponseModel<any>> {
        return this.http.delete(`${this.API_ROOT}/role`, {body: {id: id}}).map((res) => res.json());
    }

    renameRole(id: any, name: any) : Observable<ListResponseModel<any>> {
        return this.http.put(`${this.API_ROOT}/role`, {id: id, name: name}).map((res) => res.json());
    }

    clearAccount(id: any) {
        return this.http.delete(`${this.API_ROOT}/clear-account`, {body: {id: id}}).map((res) => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/models/users/users.service.ts